/**
 * Путь к файлу иконки.
 *
 * Отдельным модулем от компонента: рядом с ним функция ломает hot-reload
 * (react-refresh требует, чтобы файл экспортировал только компоненты).
 */

import { type IconName } from '@/shared/ui/icon-names'

// Vite соберёт пути на этапе сборки; сами файлы останутся отдельными
// ресурсами и загрузятся только когда браузер дойдёт до <img>.
//
// Без `query: '?url'` намеренно: для картинки Vite и так отдаёт URL в
// дефолтном экспорте, а с явным query в dev-режиме сюда попадал путь к
// JS-модулю (`...png?import&url`), и <img> грузил скрипт вместо картинки.
const FILES = import.meta.glob('../icons/*.png', {
  eager: true,
  import: 'default',
}) as Record<string, string>

export function iconUrl(name: IconName): string {
  return FILES[`../icons/${name}.png`] ?? ''
}
